module.exports = __webpack_public_path__ + "img/avatar3.a8a0a76a.png";